import { useField } from "formik";
import React from "react";

import { useStrings } from "../../localization/localizationHelpers";
import { YesNoChoice } from "../../server/crm/dataService/models/staticOptions";
import { FieldHeaderProps } from "../FieldHeader";
import { RadioOptionsField } from "../RadioOptionsField";
import { TextField } from "../TextField";

export type YesNoRadioOptionWithDetailsProps = Readonly<{
  name: string;
  detailsFieldName: string;
  detailsTitle: string;
  detailsTriggerValue: YesNoChoice;
  isSaving: boolean;
}> &
  FieldHeaderProps;

export const YesNoRadioOptionWithDetails = (props: YesNoRadioOptionWithDetailsProps) => {
  const { name, detailsFieldName, detailsTitle, detailsTriggerValue, isSaving, title } = props;
  const [yes, no] = useStrings("yes", "no");
  const [field] = useField(props);
  return (
    <>
      <RadioOptionsField
        isRequiredField
        options={[
          {
            value: YesNoChoice.yes.toString(),
            label: yes,
          },
          {
            value: YesNoChoice.no.toString(),
            label: no,
          },
        ]}
        name={name}
        title={title}
        isSaving={isSaving}
      />
      {field.value === detailsTriggerValue.toString() && (
        <TextField
          name={detailsFieldName}
          title={detailsTitle}
          isRequiredField={true}
          isSaving={isSaving}
        />
      )}
    </>
  );
};
